import { isValidElement } from 'react';
import PropTypes from 'prop-types';

const Panel = ({ title, actions, children, hasPadding = true, size }) => {

  let panelHeader;

  if (title || actions) {
    panelHeader = (
      <div className="panel__header">
        {
          title ?
            isValidElement(title) ? (
              title
            ) : (
              <h2 className="panel__title">{title}</h2>
            ) : null
        }
        { actions && <div className="panel__actions">{actions}</div> }
      </div>
    );
  }

  return (
    <div className={`panel ${!hasPadding ? `panel--no_padding` : ''} ${size ? `panel--${size}` : `panel--medium`}`}>
      {panelHeader}
      <div className="panel__content">
        {children}
      </div>
    </div>
  );

}

Panel.propTypes = {
  hasPadding: PropTypes.bool,
  size: PropTypes.oneOf(['extra_small', 'small', 'medium', 'large', 'huge']),
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
}

export default Panel;
